// envVariablesConfig.js
const backendUrl = process.env.VUE_APP_PORTAL_BACKEND_URL;
if (!backendUrl) {
  console.error('Error: VUE_APP_PORTAL_BACKEND_URL is not defined in the .env file.');
  throw new Error('Missing VUE_APP_PORTAL_BACKEND_URL in environment variables.');
}
console.log('Backend URL:', backendUrl);

const frontendUrl = process.env.VUE_APP_PORTAL_FRONTEND_URL;
if (!frontendUrl) {
  console.error('Error: VUE_APP_PORTAL_FRONTEND_URL is not defined in the .env file.');
  throw new Error('Missing VUE_APP_PORTAL_FRONTEND_URL in environment variables.');
}
console.log('Frontend URL:', frontendUrl);

const backendDomain = process.env.VUE_APP_PORTAL_BACKEND_DOMAIN;
if (!backendDomain) {
  console.error('Error: VUE_APP_PORTAL_BACKEND_DOMAIN is not defined in the .env file.');
  throw new Error('Missing VUE_APP_PORTAL_BACKEND_DOMAIN in environment variables.');
}
console.log('Backend Domain:', backendDomain);

const frontendDomain = process.env.VUE_APP_PORTAL_FRONTEND_DOMAIN;
if (!frontendDomain) {
  console.error('Error: VUE_APP_PORTAL_FRONTEND_DOMAIN is not defined in the .env file.');
  throw new Error('Missing VUE_APP_PORTAL_FRONTEND_DOMAIN in environment variables.');
}
console.log('Frontend Domain:', frontendDomain);

const keycloakUrl = process.env.VUE_APP_KEYCLOAK_URL;
if (!keycloakUrl) {
  console.error('Error: VUE_APP_KEYCLOAK_URL is not defined in the .env file.');
  throw new Error('Missing VUE_APP_KEYCLOAK_URL in environment variables.');
}
console.log('Keycloak URL:', keycloakUrl);

const homeUrl = new URL('devices', frontendUrl.replace(/\/?$/, '/')).toString();
console.log('Home URL:', homeUrl);

module.exports = {
  backendUrl,
  frontendUrl,
  backendDomain,
  frontendDomain,
  keycloakUrl,
  homeUrl
};
